import React,{useEffect, useState} from "react";
import { MAIL_ACCOUNT_ALL_LINK } from "../../../constants/constants";
import client from "../../../api";
import { notifyError, notifySuccess } from "../../../helper";
import BlockLoader from "../../BlockLoader";

const DeleteMailAccountModelWindow = (props) => {
    const { setShowAccountDeleteModelWindow, showAccountDeleteModelWindow, emailAddress } = props;
    const api = client();
    //const {campaignID} = useParams('');
    const [loading, setLoading] = useState(false);
    const [campaginLoader,setCampaginLoader] = useState(true);
    const [campaignList,setCampaignList] = useState([]);
    
    const handleMailAccountDelete = async () => {
        try{
            setLoading(true);
            const payload = {
                email: emailAddress,
            }
            
            const response = await api.post('/v1/mailAccount/delete', payload);
            if(response.status === 200 || response.status === 201){
                notifySuccess('Email Account is deleted successfully');
                setLoading(false);
                setTimeout(()=>{
                    setShowAccountDeleteModelWindow(!showAccountDeleteModelWindow);
                    window.location.href = MAIL_ACCOUNT_ALL_LINK;
                    
                },1000);
            }                
        } catch(error){
            console.log('error.message',error);
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Not able to delete Email Account');
        }
    }
    useEffect(()=>{
        const getCampaignsByMailAccount = async() => {
            try{
                setCampaginLoader(true);
                const response = await api.post("/v1/mailAccount/campaigns",{email:emailAddress});
                if(response.status === 200 || response.status === 201){
                    setCampaignList(response.data.campaigns);
                }
            } catch(error){
                setCampaginLoader(false);
                console.log("error.message",error);
                if(error.status === 400){ notifyError('Bad Request. Unable to fetch campaigns for the given mail account. Please try again') }
            } finally {
                setCampaginLoader(false);
            }
        }
        getCampaignsByMailAccount();
    },[]);
    
    return(<>
        <div className="model-window">
            <div className="overlay"></div>
            <div className="model-view">
                <div className="inner-view">
                    <h2>Are you sure?</h2>
                    <p>The following campaigns are linked to this account and will be paused if you proceed:</p>
                    {campaginLoader ? <BlockLoader height={'200px'}/> : <ul className="item-list">
                        {campaignList.length ? campaignList.map((row,index)=>(<li key={index}><span className="sr-no">{index+1}</span><span className="campaign-name">{row.campaign_name}</span></li>)):<li className="no-result">No Campaign(s) for this mail account</li>}
                    </ul>}
                    <div className="button-group">
                        <button 
                            type="button" 
                            className={loading ? "delete-btn button--loading":"delete-btn"} 
                            disabled={loading}
                            onClick={()=>handleMailAccountDelete()}>
                                <span className="button--text">Delete</span>
                        </button>                        
                        <button className="cancel-btn" onClick={()=>setShowAccountDeleteModelWindow(!showAccountDeleteModelWindow)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default DeleteMailAccountModelWindow;